<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.save_search')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.name')}}</label>
              <el-form-item prop="nombre">
                 <el-input
                  clearable
                  type="text"
                  class="w-full"
                  v-model="form.nombre"
                  maxlength='50'
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="apply('ruleForm')"/>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'

import { guardarBusqueda } from '@/services/searches/guardarBusqueda'

import { TIPOS_FILTER_MULTIPLE } from '@/config/tipos-filter-multiple'

export default
{
  name: 'create-search-dialog',
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    tags: {
      type: [Array]
    },
    idVista: {
      type: Number,
      default: -1
    },
    numberSearches: {
      type: Number,
      default: 0
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      maxSearches: 10,
      form: {
        nombre: ''
      },
      rules: {
        nombre: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ]
      },
      multipleFilters: TIPOS_FILTER_MULTIPLE,
    }
  },
  mounted: async function () {
  
  },
  computed: {
    isLimitExceed: function () {
      return this.numberSearches >= this.maxSearches
    }
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.form.nombre = ''
    },
    apply: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      if (this.isLimitExceed) {
        this.doFeedback(i18n.t('feedback.warning.max_searches_saved_warn', { maxSearches: this.maxSearches }), 'warning')
        this.$store.commit('setIsLoading', false)
        return
      }
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const payload = {
            IdVista: this.idVista,
            Nombre: this.form.nombre,
            Filtros: [],
            Version: this.$store.getters['app/version']
          }
          this.tags.forEach(element => {
            // Filtros multiples
            const tagName = this.multipleFilters.find(x => new RegExp('^' + x.NombreTag + '\\d*$').test(element[0]))?.NombreTag
            if (tagName) {
              if (Array.isArray(element[2])) {
                element[2].forEach(elValor => {
                  if (typeof elValor === 'object') payload.Filtros.push({ Clave: tagName, Valor: JSON.stringify(elValor) })
                  else payload.Filtros.push({ Clave: tagName, Valor: elValor })
                })
              } else if (typeof element[2] === 'object') {
                if (element[0] === 'empresa') {
                  payload.Filtros.push({ Clave: tagName, Valor: element[2].idCliente })
                } else if (element[0] === 'distribuidor') {
                  payload.Filtros.push({ Clave: tagName, Valor: element[2].IdDistribuidor })
                } else {
                  payload.Filtros.push({ Clave: tagName, Valor: JSON.stringify(element[2]) })
                }
              } else {
              // Filtros normales
                payload.Filtros.push({ Clave: tagName, Valor: element[2] })
              }
            } else if (Array.isArray(element[2])) {
              element[2].forEach(elValor => {
                payload.Filtros.push({ Clave: element[0], Valor: elValor })
              })
            } else if (typeof element[2] === 'object') {
              // if (element[0] === 'empresa') {
              //   payload.Filtros.push({ Clave: element[0], Valor: element[2].idCliente })
              // } else if (element[0] === 'distribuidor') {
              //   payload.Filtros.push({ Clave: element[0], Valor: element[2].IdDistribuidor })
              // } else {
              payload.Filtros.push({ Clave: element[0], Valor: JSON.stringify(element[2]) })
              // }
            } else {
              // Filtros normales
              payload.Filtros.push({ Clave: element[0], Valor: element[2] })
            }
          })
          const response = await guardarBusqueda(payload)
          if (response.blnError === true) {
            this.doFeedback(`${response.msgError} [${response.codError}]`)
          } else {
            this.doFeedback(i18n.t('feedback.success.created_search_msg'), 'success')
            this.isOpen = !this.isOpen
            // this.$emit('toggleDialog')
            this.$emit('applyDialog')
            this.form.nombre = ''
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
  }
}
</script>

<style lang="scss" scoped></style>
